import { Component, OnInit, ViewChild } from '@angular/core';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { MatSort, Sort, SortDirection } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CasedialogComponent } from '../casedialog/casedialog.component';
import { MatDialog } from '@angular/material/dialog';
import { SelectionModel } from '@angular/cdk/collections';
import {
  CompName,
  constantStrings,
  EventType,
  ROLE,
  STATUSCODESTRING,
} from '@shared/helpers/constants';
import { CasedashboardService } from '../casedashboard.service';
import { CaseHistoryData } from '@shared/models/user.model';
import { Router } from '@angular/router';
import { AuthService } from '@shared/services/auth.service';
import { interval, Subscription, takeUntil, Subject } from 'rxjs';
import { SharedStateService } from '@shared/services/shared-state.service';
import { HeaderComponent } from '../header/header.component';
import { MyCasesElement } from '../interface/my-cases.interface';
import { formatDate } from '@angular/common';
import { ProjectActionsRequestService } from '@viewer/services/project-actions-request.service';
import { IClaimantEditDetailsDto } from '@viewer/services/project-open-action.data';
import { AlertDialogService } from '@shared/alert-dialog/alert-dialog.service';
import { AlertDialogAnswer, AlertDialogResults } from '@shared/alert-dialog/alert-dialog.data';
import { parse, differenceInDays, differenceInHours, differenceInMinutes, differenceInMilliseconds, addMinutes } from 'date-fns';

@Component({
  selector: 'app-my-cases',
  templateUrl: './my-cases.component.html',
  styleUrls: ['./my-cases.component.scss'],
})
export class MyCasesComponent implements OnInit {
  private subscription: Subscription;
  displayedColumns: string[] = [
    'icons',
    'caseId',
    'anatomy',
    'imagingType',
    'caseStatus',
    'updateDateTime',
    'dueDateTime',
    'timeDifference',
    'actionsClaim',
  ];
  dataSource = new MatTableDataSource<MyCasesElement>();
  selection = new SelectionModel<any>(false, []);
  public showCaseModal: boolean = false;
  public loggedInUser: string | undefined;
  selectedImgRowIndex: any;
  isDisabled: boolean | undefined;
  statusNew = STATUSCODESTRING.statusNew;
  statusInProgress = STATUSCODESTRING.statusInProgress;
  statusProcessing = STATUSCODESTRING.statusProcessing;
  statusInReview = STATUSCODESTRING.statusInReview;
  statusRejected = STATUSCODESTRING.statusRejected;
  statusError = STATUSCODESTRING.statusError;
  statusApproved = STATUSCODESTRING.statusApproved;
  myCasesDetailsRes: any;
  myCasesData: CaseHistoryData;
  storeMyCasesData: any;
  pagelimit: number;
  displaySpinner: boolean = true;
  caseCount: number;
  totalRec: number = 0;
  errorInMyCases: any;
  caseId: any;
  selectedRowIndex: any;
  searchText: string;
  userInfo: any;
  hoursRec: number;
  days: number;
  hours: number;
  minutes: number;
  reviewerFlag: boolean = false;
  managerFlag: boolean = false;
  loggedInUserRole: string;
  totalPages: number;
  auditAction: any;
  editDialogFlag: boolean = false;
  reviewStatFlag: boolean = false;
  expandTable: boolean = false;
  caseStatus: string;
  inboundClick = false;
  compName: string = CompName.MYCASES;
  utcTime = new Date().getTimezoneOffset() * 60000;
  sortBy: string;
  sortOrder: SortDirection;
  pageNumberTemp=1;
  constructor(
    private _liveAnnouncer: LiveAnnouncer,
    public dialog: MatDialog,
    private casedashboardService: CasedashboardService,
    private authService: AuthService,
    private router: Router,
    private sharedState: SharedStateService,
    private _projectActionsRequestService: ProjectActionsRequestService,
    private alertDialogService: AlertDialogService
  ) {}

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(HeaderComponent) filterBanner;

  ngOnInit(): void {
    //To get user actions from json file
    this.sharedState.userActionStateData$.subscribe((response) => {
      this.auditAction = response;
    });
    const idToken = this.authService.getCognitoIdTokenFromStorage();
    const decodedValue = this.authService.decode(idToken);
    this.loggedInUserRole = decodedValue
      ? decodedValue['cognito:groups'][0]
      : '';
    this.loggedInUser = decodedValue ? (decodedValue['cognito_old_username']?decodedValue['cognito_old_username']:decodedValue['cognito:username']) : '';
    if (this.loggedInUserRole == ROLE.SNN_HIL_MANAGER) {
      this.managerFlag = true;
    } else if (this.loggedInUserRole == ROLE.SNN_HIL_REVIEWER) {
      this.reviewerFlag = true;
    }

    this.pagelimit = constantStrings.PageLimit;
    this.myCasesData = {
      page: 0,
      limit: this.pagelimit,
      column: 'dueDate',
      sortOrder: 'ASC',
      searchText: '',
      anatomy: [],
      sourceFacilityId: [],
      caseStatus: [9, 10, 11, 4, 16, 17, 18, 19, 21, 22, 23],
      claimantUserName: [this.loggedInUser],
      imagingType: [],
      fromDueDate: null,
      toDueDate: null,
      fromUpdatedDate: null,
      toUpdatedDate: null,
    };
    this.totalRec = 0;
    this.getMyCasesDetails(this.myCasesData);
    this.subscription = interval(1000).subscribe((x) => {
      this.calculateTimeUntilDue();
    });
  }
  /**
   * This function sets the sorting behavior of a data source in Angular after the view has been
   * initialized.
   */
  ngAfterViewInit() {
    this.dataSource.sort = null;
  }
  ngAfterViewChecked() {
    if (this.filterBanner.filterActive) {
      this.expandTable = true;
    } else {
      this.expandTable = false;
    }
  }
  /**
   * The function announces the sorting state of a table using the Angular LiveAnnouncer.
   * @param {Sort} sortState - Sort object that contains information about the current sorting state,
   * including the sorting direction.
   */
  sortTable(sortState: Sort) {
    this.sortBy = sortState.active;
    this.sortOrder = sortState.direction;
    this.myCasesData.column = sortState.active;
    this.myCasesData.sortOrder = sortState.direction;
    const columnNameDB = { 'caseStatus' : 'myCaseUploadStatus', 'updateDateTime' : 'updatedDate',
    'dueDateTime' : 'dueDate','timeDifference' : 'timeUntilDue'
     }
     this.myCasesData.column=columnNameDB[sortState.active];
    // this.myCasesData.page = 0;
    this.getMyCasesDetails(this.myCasesData);
  }
  /**
   * The function opens a dialog box to display case details and waits for the dialog to close.
   */
  viewCaseDetails(rowData): void {
    let dialogRef = this.dialog.open(CasedialogComponent, {
      autoFocus: false,
      id: 'caseDetails',
      disableClose: true,
      data: {
        id: rowData.caseId,
        status: rowData.caseStatus,
        faciltyId: rowData.sourceFacilityId,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {});
  }

  public convertStringToInt(hour: string) {
    return parseInt(hour);
  }
  highlightImg(row) {
    this.selectedImgRowIndex = row.elementId;
  }
  isDisable() {
    this.isDisabled = true;
  }
  /**
   * This function retrieves case history details from a service and updates the data source
   * accordingly.
   */
  getMyCasesDetails(params) {
    this.displaySpinner = true;
    params.page=0;
    this.casedashboardService.getCaseDashboardDetails(params).subscribe({
      next: (Response) => {
        let result = Response;
        this.displaySpinner = false;
        this.caseCount = 0;
        this.totalRec = 0;
        this.myCasesDetailsRes = result;
        this.totalPages = result.totalPages;
        if (this.myCasesData.page == 0) {
          this.storeMyCasesData = result.dashboardDetails;
        } else {
          this.storeMyCasesData = [
            ...this.storeMyCasesData,
            ...result.dashboardDetails,
          ];
        }
        this.dataSource.data = this.storeMyCasesData;
        this.calculateTimeUntilDue();
        if (
          result.dashboardDetails != null &&
          result.dashboardDetails.length &&
          this.dataSource.data.length > 0
        ) {
          this.totalRec = this.storeMyCasesData.length;
          this.caseCount = this.totalRec;
        }
      },
      error: (error) => {
        this.errorInMyCases = error;
        this.displaySpinner = false;
      },
    });
  }

  /**
   * The function increments the page number of my-casesData, sets the searchText property to the
   * current searchText, and retrieves the updated active case details.
   */
  showMore() {
    this.pageNumberTemp = this.pageNumberTemp + 1;
    this.myCasesData.limit= (this.pageNumberTemp) * 25;
    this.myCasesData.searchText = this.searchText;
    this.getMyCasesDetails(this.myCasesData);
  }
  highlightRow(row) {
    this.selectedRowIndex = row.caseId;
  }
  /**
   * This function calculates the time difference between the current date and a due date for a list of
   * items and sets flags and review times based on the difference.
   */
  calculateTimeUntilDue() {
    if (this.storeMyCasesData != undefined) {
      for (let i = 0; i < this.storeMyCasesData.length; i++) {
        const items = this.storeMyCasesData[i];
        const dateString = items?.dueDateTime;
        const parsedDate = parse(dateString, 'MM/dd/yyyy HH:mm:ss', new Date());
        const currentDate = addMinutes(new Date(), new Date().getTimezoneOffset())
        this.days = differenceInDays(parsedDate, currentDate);
        this.hours = differenceInHours(parsedDate, currentDate) % 24;
        this.minutes = differenceInMinutes(parsedDate, currentDate) % 60;
        const timeDifference = differenceInMilliseconds(parsedDate, currentDate);
        items.timeDifference = timeDifference;
        if (items.caseStatus === this.statusInReview) {
          items['caseStatus'] = this.statusInProgress;
        }
        if (items.caseStatus === STATUSCODESTRING.statusBoneModel) {
          items['caseStatus'] = this.statusProcessing;
        }
        if (
          items.caseStatus === STATUSCODESTRING.statusUploadedToMic ||
          items.caseStatus === STATUSCODESTRING.statusOnTablet ||
          items.caseStatus === STATUSCODESTRING.statusCaseComplete ||
          items.caseStatus === STATUSCODESTRING.statusCaseFailed ||
          items.caseStatus === STATUSCODESTRING.statusUploadPending ||
          items.caseStatus === STATUSCODESTRING.statusCaseCancel
        ) {
          items['caseStatus'] = this.statusApproved;
        }
        items['overDueFlag'] = false;
        items['oneDayUntilDue'] = false;
        items['dueTimeFlag'] = false;
        if (this.days >= 1) {
          items['dueTimeFlag'] = true;
          items.reviewTime = Math.floor(this.days) + ' days';
        } else if (this.hours >= 1 && this.hours < 24) {
          items['oneDayUntilDue'] = true;
          items.reviewTime = Math.floor(this.hours) + ' hours';
        } else if (this.minutes >= 1 && this.minutes < 60) {
          items['oneDayUntilDue'] = true;
          items.reviewTime = Math.floor(this.minutes) + ' minutes';
        } else if (this.days < 1) {
          items['overDueFlag'] = true;
          if(this.days == 0){
            if(this.hours > -1 && this.minutes <= 0){
              items.reviewTime = `${this.minutes} minutes`;
            }
            else{
              items.reviewTime = `${this.hours} hours`;
            }
          } 
          else{
            items.reviewTime = `${this.days} days`;
          }
        }
      }
    }
  }
  //This method is called on header Comp Search Button Click
  search(txt : any) {
    this.searchText = txt || '';
    this.myCasesData.searchText = this.searchText;
    this.myCasesData.page = 0;
    this.getMyCasesDetails(this.myCasesData);
  }
  searchIconClick(checked) {
    //converting current Date and time to UTC date and Time
    let curDtTimeUTC = new Date().getTime() + this.utcTime;
    let apiCurDtTimeUTC = formatDate(
      curDtTimeUTC,
      'MM/dd/yyyy HH:mm:ss',
      'en-US'
    );

    this.myCasesData.page = 0;
    this.myCasesData.caseStatus = [9, 10, 11, 4, 16, 17, 18, 19, 21, 22, 23];
    this.myCasesData.fromDueDate = null;
    this.myCasesData.toDueDate = null;
    //check for Error cases
    if (checked.isErrorChecked != undefined && checked.isErrorChecked) {
      this.myCasesData.caseStatus = [4, 11];
    }
    //check for overdue cases
    if (checked.isRedFlagChecked != undefined && checked.isRedFlagChecked) {
      this.myCasesData.fromDueDate = null;
      this.myCasesData.caseStatus=[];
      this.myCasesData.caseStatus = [4, 9, 11, 16];
      this.myCasesData.fromDueDate = constantStrings.startTimeDue;
      this.myCasesData.toDueDate = apiCurDtTimeUTC;
    }
    //check for 24hr due date
    if (checked.isDayFlagChecked != undefined && checked.isDayFlagChecked) {
      let twentyfourHours =
        new Date().getTime() + 24 * 60 * 60 * 1000 + this.utcTime;
      this.myCasesData.fromDueDate = apiCurDtTimeUTC;
      this.myCasesData.toDueDate = formatDate(
        twentyfourHours,
        'MM/dd/yyyy HH:mm:ss',
        'en-US'
      );
    }
    this.getMyCasesDetails(this.myCasesData);
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  _unsubscribe$ = new Subject();
  //This method is called on click of open button
  navigateMRI(caseid, caseStatus) {
    if(caseStatus == this.statusInProgress || caseStatus == this.statusProcessing){
      this._projectActionsRequestService
      .requestUpdateEditCaseDetails(caseid)
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe((data: IClaimantEditDetailsDto) => {
        const checkDiffUser = data.claimantUserName != data.lastClaimantUserName;
        const checkEditcaseUser = data.claimantUserName != data.claimantSavedUserName;
        if (data.isCaseEdited === 1 && (checkDiffUser && checkEditcaseUser)) {
          this.alertDialogService.openConfirmDialog(
            'Dialog.OPEN_EDIT_CASE',
            'Dialog.RejectButtons.EXIT',
            'Dialog.ConfirmButtons.CONTINUE'
          ).pipe(takeUntil(this._unsubscribe$))
          .subscribe((res: AlertDialogAnswer) => {
            if (res.result === AlertDialogResults[1]) {
              this._projectActionsRequestService
              .requestUpdateEditCaseStatus(
                caseid,
                0,
                data.claimantSavedUserName
              )
              .subscribe();
              localStorage.setItem("caseId",caseid);
              this.router.navigate([caseid, 'patientviewer']);
            }
          });
        } else {
          localStorage.setItem("caseId",caseid);
          this.router.navigate([caseid, 'patientviewer']);
        }
      });
      this.auditLogActivity(
        EventType.read,
        this.auditAction.UserActions.caseEditMode
      );
    } else {
      localStorage.setItem("caseId",caseid);
      this.router.navigate([caseid, 'patientviewer']);
      this.auditLogActivity(
        EventType.read,
        this.auditAction.UserActions.caseEditMode
      );
    }
  }
  loadFilterData(caseData) {
    this.myCasesData.page = 0;
    this.myCasesData.anatomy = caseData.anatomy;
    this.myCasesData.caseStatus =
      caseData.caseStatus.length > 0 ? caseData.caseStatus : [];
    if (this.myCasesData.caseStatus.includes(10)) {
      const statusesToAdd = [17, 18, 19, 21, 22, 23];
      statusesToAdd.forEach(status => {
        if (!this.myCasesData.caseStatus.includes(status)) {
          this.myCasesData.caseStatus.push(status);
        }
      });
    } else if (!this.myCasesData.caseStatus.includes(10)) {
      let values = [17, 18, 19, 21, 22, 23];
      this.myCasesData.caseStatus = this.myCasesData.caseStatus.filter(
        (item) => !values.includes(item)
      );
    }
    if (this.myCasesData.caseStatus.length <= 0) {
      this.myCasesData.caseStatus = [9, 10, 11, 4, 16, 17, 18, 19, 21, 22, 23];
    }
    this.myCasesData.claimantUserName = [this.loggedInUser];
    this.myCasesData.fromDueDate = caseData.fromDueDate;
    this.myCasesData.fromUpdatedDate = caseData.fromUpdatedDate;
    this.myCasesData.imagingType = caseData.imagingType;
    this.myCasesData.sourceFacilityId = caseData.sourceFacilityId;
    this.myCasesData.toDueDate = caseData.toDueDate;
    this.myCasesData.toUpdatedDate = caseData.toUpdatedDate;
    this.getMyCasesDetails(this.myCasesData);
  }

  /**
   * This function logs an audit activity with details such as case ID, user information, date and time,
   * action, event type, and outcome.
   */
  auditLogActivity(eventName, actionName) {
    let auditLogTime = new Date();
    let action = {
      caseId: this.caseId ? this.caseId : '',
      userName: this.casedashboardService.loggedInUserName,
      dateTime: auditLogTime,
      action: actionName,
      eventOutCome: 1,
      eventType: eventName,
    };
    this.casedashboardService.auditLogActivity(action).subscribe({
      next: (Response) => {       
      },
      error: (error) => {},
    });
  }
}
